<template>
    <div class="sig-edit content-container">
        <div class="header">
            <div class="title">Signature</div>
        </div>        
        <div class="content">
            <div class="edit-large">
                <Editor ref="editor" v-if="!useCkEditor"></Editor>
                 <HtmlEditor  v-model="editorContent" v-if="useCkEditor" />
            </div>
        </div>
        <div class="footer">
            <div class="footer-right">
                <button v-on:click="cancel" >Cancel</button>
                <button v-on:click="submit">Submit</button>
            </div>
        </div>
    </div>
</template>

<script>

    import api from '../../api/api'
    import Editor from '../../components/Posts/Editor.vue'
    import dialogs from '../../modules/dialogs';
    import HtmlEditor from '../../components/Widgets/HtmlEditor';
    import settings from "../../modules/settings";

    export default {

        props: ['signatureInfo'],
        components: {
            Editor,
            HtmlEditor,
        },
        data() {
            return {
                id: null,
                signature: null,
                originalSignature: null,
                editorContent: "",
            }
        },
        computed: {
            useCkEditor: function() {
                return settings.user.getUseCKEditor();
            },
        },
        methods: {
            submit() {

                let data = {};
                let sig = '';
                if (this.useCkEditor) {
                    sig = this.editorContent;
                } 
                else {
                    sig = this.$refs.editor.getValue();
                }

                data.memberID = parseInt(this.id);
                data.signature = sig;

                api.post('/members/' + this.id + '/signature', data)
                    .then(async (response) => {
                        this.modalIsConfirm = false;
                        if (response.data.success === true) {
                            this.originalSignature = this.signature;
                            await dialogs.alertAsync("Saved");
                        } else {
                            await dialogs.alertAsync(response.data.message);
                        }
                    }
                ).catch(async (error) => {
                    await dialogs.alertAsync(error);
                });
            },
            async cancel() {
                if(await dialogs.confirmAsync("Are you sure you want to cancel edits to your signature?")) {
                    this.signature = this.originalSignature;
                    let formattedContent =this.signature;
                    this.setEditorValue(formattedContent);
                }
            },
            setEditorValue(value) {
                if (this.useCkEditor) {
                    this.editorContent = value;
                }
                else {
                    this.$refs.editor.setValue(value);
                }
            }
        },
        mounted() {
            this.id = this.signatureInfo.id;
            this.signature = this.signatureInfo.signature;
            this.originalSignature = this.signatureInfo.signature;

            let formattedContent =this.signature;
            this.setEditorValue(formattedContent);
        }

    }

</script>

